const shareUrl = 'https://z.ynet.co.il/short/content/2018/70road/';

const urls = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
    whatsapp: `whatsapp://send?text=${shareUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${shareUrl}`
}

export {
    shareUrl,
    urls
}


// WEBPACK FOOTER //
// ./src/consts.js